module.exports = __webpack_public_path__ + "media/images/flags/1x1/bes-52314fe2fc8020d913f170b4a5dfbaa1.svg";